import React, { useEffect, useState } from 'react';
import { Col, Form, Row } from 'antd';
import { FormField } from 'components'; 
import { updateFormField } from 'store/forms/actions';
import { formFields, formFields1, formFields2, formFieldsCo, formFieldsCost, formFieldsDeg } from './formFields'; 
import { useDispatch, useSelector } from 'react-redux';
import { get, omit, isEmpty, isNil } from 'lodash';
import moment from 'moment';
import { useForm } from 'antd/lib/form/Form';
import { currencyFormatter, formattedNumber, isBeneficiary, validatePhoneNumber } from 'utils'; 
import { ReactComponent as Cancel } from 'assets/icons/cancel_icon.svg';
import { tkDegDaysArray } from 'utils/tkDegDaysArray';
import { getTaxisDataByTk } from 'store/user/actions';


const BuildingDetails = () => {
  const dispatch = useDispatch();
  const [requiredFieldsError, setRequiredFieldsError] = useState(true);
  const carrier = useSelector(state => state.forms.carrier);
  const user = useSelector(state => state.user);
  const XEDM = useSelector(state => state.forms.XEDM);
  const thermIns = useSelector(state => state.forms.carrier.thermIns);
  const shellReplace = useSelector(state => state.forms.carrier.shellReplace);
  const upgradeSys = useSelector(state => state.forms.carrier.upgradeSys);
  const otherServices = useSelector(state => state.forms.carrier.otherServices);
  const amountThermIns = useSelector(state => state.forms.carrier.amountThermIns) || '0,00';
  const amountShellReplace = useSelector(state => state.forms.carrier.amountShellReplace) || '0,00';
  const amountUpgradeSys = useSelector(state => state.forms.carrier.amountUpgradeSys) || '0,00';
  const amountOtherServices = useSelector(state => state.forms.carrier.amountOtherServices) || '0,00';
  const amountThermInsFpa = useSelector(state => state.forms.carrier.amountThermInsFpa) || '0,00';
  const amountShellReplaceFpa = useSelector(state => state.forms.carrier.amountShellReplaceFpa) || '0,00';
  const amountUpgradeSysFpa = useSelector(state => state.forms.carrier.amountUpgradeSysFpa) || '0,00';
  const amountOtherServicesFpa = useSelector(state => state.forms.carrier.amountOtherServicesFpa) || '0,00';

  const totalCost = useSelector(state => state.forms.carrier.totalCost) || '0,00';
  const totalFpa = useSelector(state => state.forms.carrier.totalFpa) || '0,00';
  const isViewMode = useSelector(state => state.forms.carrier.viewMode);
  const viewMode = isViewMode || !isBeneficiary(user.groups);
  const [form] = useForm();
  const coHousing = useSelector(state => state.forms.carrier.coHousing);
  const buildTk = useSelector(state => state.forms.carrier.buildTk);

  const handleChange = ({ key, type, event }) => {
    let newValue;

    if (type === 'text' || type === 'textarea' || type === 'radio') {
      newValue = event.target.value;
    } else if (type === 'date') {
      newValue = new Date(event).toLocaleDateString();
    } else if (type === 'checkbox') {
      newValue = event.target.checked;
    } else if (
      type === 'select' ||
      type === 'number' ||
      type === 'numberWithDecimals' ||
      type === 'formattedNumber'
    ) {
      newValue = event;
    }

    if (key === "thermIns") {
      const isUnchecked = newValue == false;
      if (isUnchecked) {
        form.setFieldsValue({
          amountThermIns: null,
          amountThermInsFpa: null

        });
        dispatch(updateFormField({ group: 'carrier', key: 'amountThermIns', value: null }));
        dispatch(updateFormField({ group: 'carrier', key: 'amountThermInsFpa', value: null }));
      }
    }

    if (key === "shellReplace") {
      const isUnchecked = newValue == false;
      if (isUnchecked) {
        form.setFieldsValue({
          amountShellReplace: null,
          amountShellReplaceFpa: null

        });
        dispatch(updateFormField({ group: 'carrier', key: 'amountShellReplace', value: null }));
        dispatch(updateFormField({ group: 'carrier', key: 'amountShellReplaceFpa', value: null }));
      }
    }
    if (key === "upgradeSys") {
      const isUnchecked = newValue == false;
      if (isUnchecked) {
        form.setFieldsValue({
          amountUpgradeSys: null,
          amountUpgradeSysFpa: null

        });
        dispatch(updateFormField({ group: 'carrier', key: 'amountUpgradeSys', value: null }));
        dispatch(updateFormField({ group: 'carrier', key: 'amountUpgradeSysFpa', value: null }));
      }
    }
    if (key === "otherServices") {
      const isUnchecked = newValue == false;
      if (isUnchecked) {
        form.setFieldsValue({
          amountOtherServices: null,
          amountOtherServicesFpa: null

        });
        dispatch(updateFormField({ group: 'carrier', key: 'amountOtherServices', value: null }));
        dispatch(updateFormField({ group: 'carrier', key: 'amountOtherServicesFpa', value: null }));
      }
    }

    dispatch(updateFormField({ group: 'carrier', key, value: newValue }));
  };

  const renderFieldValue = field => {
    const value = get(carrier, field.name, '');

    // Handle empty string value for select
    if (field.type === 'select') return value || undefined;
    if (field.type === 'date') return value ? moment(value) : '';
    return value;
  };

  useEffect(() => {
    const deg = tkDegDaysArray.find(b => b.tk == carrier.buildTk)?.value;
        dispatch(updateFormField({ group: 'carrier', key: 'degDays', value: deg }));
        form.setFieldsValue({
          degDays: deg,
        });
  },[carrier?.buildTk]);

  // useEffect(() => {
  //   form.setFieldsValue({
  //     thermIns: thermIns,
  //     shellReplace: shellReplace,
  //     upgradeSys: upgradeSys,
  //     otherServices: otherServices,
  //   });
  // }, [form, thermIns, shellReplace, upgradeSys, otherServices]);

  useEffect(() => {

    const amount = parseFloat(amountThermIns?.replaceAll(',','.')) + 
    parseFloat(amountShellReplace?.replaceAll(',','.')) +
    parseFloat(amountUpgradeSys?.replaceAll(',','.')) +
    parseFloat(amountOtherServices?.replaceAll(',','.')) 

    dispatch(updateFormField({ group: 'carrier', key: 'totalCost', value: amount }));
    form.setFieldsValue({
      totalCost: amount,
    });
  },[amountThermIns, amountShellReplace, amountUpgradeSys, amountOtherServices])

  useEffect(() => {

    const amountFpa = parseFloat(amountThermInsFpa?.replaceAll(',','.')) + 
    parseFloat(amountShellReplaceFpa?.replaceAll(',','.')) +
    parseFloat(amountUpgradeSysFpa?.replaceAll(',','.')) +
    parseFloat(amountOtherServicesFpa?.replaceAll(',','.')) 
    

    dispatch(updateFormField({ group: 'carrier', key: 'totalFpa', value: amountFpa }));
    form.setFieldsValue({
      totalFpa: amountFpa,
    });
  },[amountThermInsFpa, amountShellReplaceFpa, amountUpgradeSysFpa, amountOtherServicesFpa])

  useEffect(() => {

    const amount = parseFloat(totalCost) + parseFloat(totalFpa)

    dispatch(updateFormField({ group: 'carrier', key: 'totalCostWithFpa', value: amount }));
    form.setFieldsValue({
      totalCostWithFpa: amount,
    });
  },[totalCost, totalFpa])

  useEffect(() => {
    if (!isNil(buildTk)) {
      if (buildTk.toString().length === 5)
         {
      dispatch(getTaxisDataByTk(buildTk));
      }
    }
  }, [buildTk]);

  useEffect(() => {

    if (!isNil(buildTk) && buildTk.toString().length < 5) {
      dispatch(
        updateFormField({
          group: 'carrier',
          key: 'buildPerfecture',
          value: null
        })
      )
      dispatch(
        updateFormField({
          group: 'carrier',
          key: 'buildDistrict',
          value: null
        })
      )
      form.setFieldsValue({
        buildPerfecture: null,
        buildDistrict: null,
      });
    }
  }, [buildTk]);

  useEffect(() => {
    if (carrier.taxis_data_by_tk) {
      dispatch(
        updateFormField({
          group: 'carrier',
          key: 'perfectureLoc',
          value: carrier?.taxis_data_by_tk[0]?.nomos,
        })
      );
      dispatch(
        updateFormField({
          group: 'carrier',
          key: 'district_by_tk',
          value: carrier.taxis_data_by_tk.map(value => {
            return { label: value.area, value: value.area };
          }),
        })
      );
    }
  }, [carrier.taxis_data_by_tk]);



  return (
    <div className="">
       {!viewMode && requiredFieldsError && (
        <div className="stepper-warning-message error-message">
          <div>
            Για την ενεργοποίηση της υποβολής είναι υποχρεωτική η επιλογή τουλάχιστον μίας δαπάνης.
          </div>
          <Cancel
            className="cancel-icon"
            onClick={() => setRequiredFieldsError(false)}
          />
        </div>
      )}
      <Form 
      form={form} 
      initialValues={{ ...carrier }} 
      trigger="onChange">
        <div className="carrier-data-form">
        <Row
            gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
            className="carrier-data-form__row"
          >
          <Col key={'empty-col'} className="gutter-row" span={24}></Col>
          {formFields2.map((field) => {
            return (
                <Col key={field.id} className="gutter-row" span={field.span}>
                  <Form.Item
                    name={field.name}
                    rules={field.rules}
                    validateFirst
                    initialValue={renderFieldValue(field)}
                  >
                    <FormField
                      disabled={field?.disabled ?? viewMode}
                      {...omit(field, ['span', 'rules', 'disabled'])}
                      options={field.options || []}
                      onChange={value =>
                        handleChange({
                          key: field.name,
                          type: field.type,
                          event: value,
                        })
                      }
                    />
                  </Form.Item>
                </Col>
            )
              })} 
          {coHousing && formFieldsCo.map((field) => {
            return (
                <Col key={field.id} className="gutter-row" span={field.span}>
                  <Form.Item
                    name={field.name}
                    rules={field.rules}
                    validateFirst
                    initialValue={renderFieldValue(field)}
                  >
                    <FormField
                      disabled={field?.disabled ?? viewMode}
                      {...omit(field, ['span', 'rules', 'disabled'])}
                      options={field.options || []}
                      onChange={value =>
                        handleChange({
                          key: field.name,
                          type: field.type,
                          event: value,
                        })
                      }
                    />
                  </Form.Item>
                </Col>
            )
              })} 
              </Row>   
          <p className="mr-0 mt-3 color-blue-3 text-bold font-size-24">Στοιχεία Κτιρίου</p>
          <Row
            gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
            className="carrier-data-form__row"
          >
            {formFields.map((field) => {
              return (
              <Col key={field.id} className="gutter-row" span={field.span}>
                <Form.Item
                  name={field.name}
                  rules={field.rules}
                  validateFirst
                  initialValue={renderFieldValue(field)}
                >
                  <FormField
                    disabled={field?.disabled ?? viewMode}
                    {...omit(field, ['span', 'rules', 'disabled'])}
                    options={
                      field.name === 'buildPerfecture'
                        ? carrier.buildPerfectureOptions &&
                          carrier.buildPerfectureOptions.map(b => ({
                            value: b.value,
                          }))
                        : field.name === 'buildDistrict' ? 
                        carrier.buildDistrictOptions &&
                        carrier.buildDistrictOptions.map(b => ({
                          value: b.value,
                        })) : field.options
                    }
                    onChange={value =>
                      handleChange({
                        key: field.name,
                        type: field.type,
                        event: value,
                      })
                    }
                  />
                </Form.Item>
              </Col>
              )
            })}
            </Row>
            </div>
            <div className='carrier-data-form carrier-data-form__right'>
            <div className="">
              <p className="mt-3 mr-0 color-blue-3 text-bold font-size-24">
                Κόστος Παρέμβασης            
                </p>
            </div>
            <div className='expensesContainer'> 
          <Row
            gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
            className="carrier-data-form__row"
          >
            <Col key={'title'} className="gutter-row expenses-inner-title" span={24}>Τύπος Δαπάνης</Col>
            {formFields1.map((field) => {
              return (
              <Col key={field.id} className="gutter-row" span={field.span}>
                <Form.Item
                  name={field.name}
                  rules={field.rules}
                  initialValue={renderFieldValue(field)}
                  valuePropName={(field.name === 'thermIns' || 
                  field.name === 'shellReplace' ||
                  field.name === 'upgradeSys' ||
                  field.name === 'otherServices' )? "checked" : 'value'}
                >
                  <FormField
                    {...omit(field, ['span', 'rules', 'disabled'])}
                    disabled={viewMode 
                      || (field.name === 'amountThermIns' ? thermIns? field?.disabled : true : field?.disabled) 
                      || (field.name === 'amountThermInsFpa' ? thermIns? field?.disabled : true : field?.disabled) 
                      || (field.name === 'amountShellReplace' ? shellReplace? field?.disabled : true : field?.disabled) 
                      || (field.name === 'amountShellReplaceFpa' ? shellReplace? field?.disabled : true : field?.disabled) 
                      || (field.name === 'amountUpgradeSys' ? upgradeSys? field?.disabled : true : field?.disabled) 
                      || (field.name === 'amountUpgradeSysFpa' ? upgradeSys? field?.disabled : true : field?.disabled) 
                      || (field.name === 'amountOtherServices' ? otherServices? field?.disabled : true : field?.disabled) 
                      || (field.name === 'amountOtherServicesFpa' ? otherServices? field?.disabled : true : field?.disabled) 
                    }
                    label={
                      <>
                        {field.label}
                        
                      </>
                    }
                    onChange={value => {
                      handleChange({
                        key: field.name,
                        type: field.type,
                        event: value,
                      });
                    }}
                  />
                </Form.Item>
              </Col>
              );
            })}
            </Row>
            </div>
            <div className='costContainer'>
            <Row
            gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
            className="carrier-data-form__row"
          >
           
            {formFieldsCost.map((field) => {
              return (
                <React.Fragment key={field.id}>
                  <Col  className="gutter-row mt-1" span={14}>
                    <div className='font-size-16'>{field.title}</div>
                  </Col>
                  <Col className="gutter-row" span={10}>
                    <Form.Item
                      name={field.name}
                      rules={field.rules}
                      validateFirst
                      initialValue={renderFieldValue(field)}
                    >
                      <FormField
                        disabled={field?.disabled ?? viewMode}
                        {...omit(field, ['span', 'rules', 'disabled'])}
                        options={field.options || []}
                        onChange={value =>
                          handleChange({
                            key: field.name,
                            type: field.type,
                            event: value,
                          })
                        }
                      />
                    </Form.Item>
                  </Col>
                </React.Fragment>
              )
            })}
            </Row>
            </div>
            <Row
            gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
            className="carrier-data-form__row"
          >

            {formFieldsDeg.map((field) => {
              return (
              <Col key={field.id} className="gutter-row" span={24}>
                <Form.Item
                  name={field.name}
                  rules={field.rules}
                  validateFirst
                  initialValue={renderFieldValue(field)}
                >
                  <FormField
                    disabled={field?.disabled ?? viewMode}
                    {...omit(field, ['span', 'rules', 'disabled'])}
                    options={field.options || []}
                    onChange={value =>
                      handleChange({
                        key: field.name,
                        type: field.type,
                        event: value,
                      })
                    }
                  />
                </Form.Item>
              </Col>
              )
            })}
            </Row>
        
            </div>
        
      </Form>
    </div>
  );
};

export default BuildingDetails;
